import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import DOMPurify from "dompurify";

// SVG Images
import Back from "../../assets/svg/back.svg";
import Service from "../../assets/svg/service.svg";
import { createAnnouncementApi, getAnnouncementDetailsApi, getServiceListApi, UpdateAnnouncementApi } from "./announcement-api";

const AnnouncementAdd = () => {
  const navigate = useNavigate();

  //useLocation
  const location = useLocation();
  const { id } = location.state || {};

  //Borders
  const [nameBorder, setNameBorder] = useState("#D4DDE7");
  const [emailBorder, setEmailBorder] = useState("#D4DDE7");
  const [industryBorder, setIndustryBorder] = useState("#D4DDE7");
  const [messageBorder, setMessageBorder] = useState("#D4DDE7");

  //Inputs
  const [name, setName] = useState("");
  const [industry, setIndustry] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [validations, setValidations] = useState({
    name: "",
    email: "",
    industry: "",
    message: "",
    service_id: "",
  });

  //Get Service

  const [serviceList, setServiceList] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);

  const getServiceList = async () => {
    try {
      const response = await getServiceListApi("");
      if (response.data.success === true) {
        setServiceList(
          response.data.suggestionlist.map((item) => ({
            value: item.value,
            label: item.label,
            icon: item.icon,
          }))
        );
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching services:", err);
    }
  };

  useEffect(() => {
    getServiceList();
  }, []);

  // Toggle service selection
  const handleSelectService = (value) => {
    setSelectedServices((prevSelected) => (prevSelected.includes(value) ? prevSelected.filter((item) => item !== value) : [...prevSelected, value]));
  };

  //Submit Data
  const submitCall = async () => {
    const dataBeforeSanitize = {
      name: name,
      email: email,
      industry: industry,
      message: message,
      service_id: selectedServices,
    };

    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });

    let response;
    if (id != null) {
      response = await UpdateAnnouncementApi(dataAfterSanitize, id);
    } else {
      response = await createAnnouncementApi(dataAfterSanitize);
    }

    if (response.status === 200) {
      if (response.data.success === true) {
        navigate("/announcement/list");
      }
    }
    if (response.status === 400) {
      new Promise((resolve, reject) => {
        const validationTemp = {
          name: "",
          email: "",
          industry: "",
          message: "",
          service_id: "",
        };

        Object.entries(response.data.error).forEach(([key, value]) => {
          console.log(`${key}: ${value}`);
          const baseKey = key.includes(".") ? key.split(".")[0] : key;
          if (baseKey in validationTemp) {
            validationTemp[baseKey] = Array.isArray(value) && value.length > 0 ? value[0] : "";
          }
        });

        console.log("validationTemp...", validationTemp);
        setValidations(validationTemp);
      });
    }
  };

  //Edit
  useEffect(() => {
    if (id != null) getAnnouncementDetails();
  }, []);

  const getAnnouncementDetails = async () => {
    try {
      const response = await getAnnouncementDetailsApi(id);
      if (response.success === true && response.data) {
        const details = response.data;

        setName(details.name || "");
        setEmail(details.email || "");
        setIndustry(details.industry || "");
        setMessage(details.message || "");
        setSelectedServices(details.service_id || []);
      }
    } catch (err) {
      console.error("Error fetching call details:", err);
    }
  };

  return (
    <div style={{ fontFamily: "'Euclid Circular B', sans-serif", padding: "16px", height: "100vh", width: "83vw", overflowX: "hidden", backgroundColor: "#f8f9fb" }}>
      <div style={{ marginBottom: "32px" }}>
        <Row className="align-items-center justify-content-between" style={{ width: "100%" }}>
          <Col sm={12} md={6} lg={8}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <img src={Back} style={{ width: "40px" }} alt="Back" onClick={() => navigate(-1)} />
              <div style={{ fontWeight: "500", fontSize: "20px", color: "#172b4d" }}>New Announcement</div>
            </div>
          </Col>

          <Col sm={12} md={6} lg={4}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", justifyContent: "flex-end" }}>
              <button style={{ fontWeight: "500", fontSize: "16px", color: "#21272c", height: "40px", borderRadius: "100px", border: "1px solid #d4dde7", backgroundColor: "#ffffff", padding: "10px 28px", lineHeight: "100%" }} onClick={() => navigate(-1)}>
                Cancel
              </button>
              <button onClick={submitCall} style={{ fontWeight: "500", fontSize: "16px", color: "#ffffff", height: "40px", borderRadius: "100px", backgroundColor: "#3d4af5", padding: "10px 28px", lineHeight: "100%", border: "none" }}>
                Save
              </button>
            </div>
          </Col>
        </Row>
      </div>

      <Row>
        <Col sm={12} md={12} lg={7}>
          <div style={{ height: "fit-content", borderRadius: "24px", padding: "24px", backgroundColor: "#ffffff" }}>
            <Row style={{ marginBottom: "32px" }}>
              <Col sm={12}>
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <div style={{ fontWeight: "500", fontSize: "20px", color: "#172b4d" }}>Announcement details</div>
                  <div style={{ fontWeight: "400", fontSize: "16px", color: "#172b4d" }}>Enter below details to create new announcement</div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col sm={12}>
                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ fontWeight: "400", fontSize: "14px", color: "#21272c" }}>Name</div>
                    <input value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder="Enter name" style={{ width: "100%", height: "44px", borderRadius: "10px", padding: "16px", border: `1.5px solid ${nameBorder}`, backgroundColor: "#ffffff", fontWeight: "400", fontSize: "14px", color: "#172b4d", outline: "none" }} onFocus={() => setNameBorder("#3D4AF5")} onBlur={() => setNameBorder("#D4DDE7")} />
                    <span style={{ fontWeight: "300", fontSize: "13px", color: "#ff4444" }}>{validations.name}</span>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ fontWeight: "400", fontSize: "14px", color: "#21272c" }}>Email</div>
                    <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Enter email" style={{ width: "100%", height: "44px", borderRadius: "10px", padding: "16px", border: `1.5px solid ${emailBorder}`, backgroundColor: "#ffffff", fontWeight: "400", fontSize: "14px", color: "#172b4d", outline: "none" }} onFocus={() => setEmailBorder("#3D4AF5")} onBlur={() => setEmailBorder("#D4DDE7")} />
                    <span style={{ fontWeight: "300", fontSize: "13px", color: "#ff4444" }}>{validations.email}</span>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ fontWeight: "400", fontSize: "14px", color: "#21272c" }}>Industry</div>
                    <select value={industry} onChange={(e) => setIndustry(e.target.value)} style={{ width: "100%", height: "44px", borderRadius: "10px", padding: "0px 16px", border: `1.5px solid ${industryBorder}`, backgroundColor: "#ffffff", fontWeight: "400", fontSize: "14px", color: "#172b4d", outline: "none" }} onFocus={() => setIndustryBorder("#3D4AF5")} onBlur={() => setIndustryBorder("#D4DDE7")}>
                      <option value="">Choose industry</option>
                      <option value="Healthcare">Healthcare</option>
                      <option value="Technology">Technology</option>
                      <option value="Finance">Finance</option>
                    </select>
                    <span style={{ fontWeight: "300", fontSize: "13px", color: "#ff4444" }}>{validations.industry}</span>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ fontWeight: "400", fontSize: "14px", color: "#21272c" }}>Message</div>
                    <textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Enter message" style={{ width: "100%", height: "100px", borderRadius: "10px", padding: "16px", border: `1.5px solid ${messageBorder}`, backgroundColor: "#ffffff", fontWeight: "400", fontSize: "14px", color: "#172b4d", outline: "none", resize: "none" }} onFocus={() => setMessageBorder("#3D4AF5")} onBlur={() => setMessageBorder("#D4DDE7")} />
                    <span style={{ fontWeight: "300", fontSize: "13px", color: "#ff4444" }}>{validations.message}</span>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>

        <Col sm={12} md={12} lg={5}>
          <div style={{ height: "fit-content", borderRadius: "24px", padding: "24px", backgroundColor: "#ffffff" }}>
            <Row style={{ marginBottom: "32px" }}>
              <Col sm={12}>
                <div style={{ fontWeight: "500", fontSize: "20px", color: "#172b4d" }}>Select services</div>
                <span style={{ fontWeight: "300", fontSize: "13px", color: "#ff4444" }}>{validations.service_id}</span>
              </Col>
            </Row>

            <Row>
              {serviceList.map((service) => {
                const isSelected = selectedServices.includes(service.value);
                return (
                  <Col key={service.value} sm={6} md={4} className="mb-3" onClick={() => handleSelectService(service.value)} style={{ cursor: "pointer" }}>
                    <div style={{ borderRadius: "20px", padding: "12px 16px", backgroundColor: isSelected ? "#EDEEFF" : "#f8f8f8", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "12px", height: "100px", border: isSelected ? "1px solid #5A4FF3" : "none", transition: "0.2s ease" }}>
                      <div>
                        <img src={service.icon || Service} style={{ height: "32px" }} alt="Service Icon" />
                      </div>
                      <div style={{ fontWeight: "400", fontSize: "14px", color: "#172b4d", width: "100%",display:'flex',justifyContent:'center',alignItems:'center' }} title={service.label}>
                        {service.label}
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AnnouncementAdd;
